import { AppConfiguration } from './app.config.interface';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG_FILE } from '../utils/constants';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  appConfiguration!: AppConfiguration;

  constructor(private http: HttpClient) {}

  loadConfiguration() {
    console.log('AppConfigService::loadConfiguration', APP_CONFIG_FILE);

    return new Promise((r, e) => {
      this.http.get<AppConfiguration>(APP_CONFIG_FILE).subscribe({
        next: (value: AppConfiguration) => {
          this.appConfiguration = value;
          r(this);
        },
        error: (err: HttpErrorResponse) => {
          console.log("Erreur en récupérant le fichier de configuration de l'application", err.message);
          e(err);
        }
      });
    });
  }

  public getUrls() {
    return this.appConfiguration.urls;
  }

  public getInfoBuild() {
    return this.appConfiguration.info.build;
  }
}
